import { render, staticRenderFns } from "./uploadArea.vue?vue&type=template&id=1a04fe84"
import script from "./uploadArea.vue?vue&type=script&lang=js"
export * from "./uploadArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports